import React from 'react'
import {useIntl} from 'react-intl'

interface EmptyStateProps {
  theme: 'light' | 'dark'
  isCompact?: boolean
}

const EmptyState: React.FC<EmptyStateProps> = ({isCompact = false}) => {
  const intl = useIntl()

  return (
    <div
      className='d-flex flex-column align-items-center justify-content-center text-center'
      style={{height: '100%', padding: isCompact ? '8px' : '0'}}
    >
      <h4
        style={{
          fontSize: isCompact ? '1rem' : '1.1rem',
          color: 'var(--chatbot-text-primary)',
          marginBottom: 6,
        }}
      >
        {intl.formatMessage({id: 'CHAT.EMPTY.TITLE'})}
      </h4>
      <p
        style={{
          marginBottom: isCompact ? '0' : undefined,
          color: 'var(--chatbot-text-secondary)',
          fontSize: '0.85rem',
          maxWidth: 260,
        }}
      >
        {intl.formatMessage({id: 'CHAT.EMPTY.DESCRIPTION'})}
      </p>
    </div>
  )
}

export default EmptyState
